import { CustomDialog } from "@/components/ui-elements";
// import { useDeleteWorkflow } from "@/features/workflow/api/deleteWorkflow";
import { useFolderData } from "@/components/ui-elements/SideMenu/hooks/useFolderData";
import { queryClient } from "@/lib/react-query";
import type { GetFolderResponse } from "@/types/resources";
import type { ForwardRefRenderFunction } from "react";
import { forwardRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";

interface DeleteFolderPopupProps {
  // 削除するフォルダのID
  folderId: string | undefined;
  selectedFolderLabel: string;
  onClose: () => void;
}

const DeleteFolderPopupComponent: ForwardRefRenderFunction<
  HTMLDivElement,
  DeleteFolderPopupProps
> = ({ folderId, selectedFolderLabel, onClose }: DeleteFolderPopupProps) => {
  const { deleteFolder } = useFolderData();
  const navigation = useNavigate();

  // フォルダを削除する関数
  const handleDelete = useCallback(async () => {
    if (!folderId) {
      return;
    }

    try {
      // 削除対象のフォルダ内に現在表示中のワークフローが含まれているかチェック
      const folderData = queryClient.getQueryData<GetFolderResponse>("folders");
      const targetFolder = folderData?.folders.find(
        (folder) => folder.id === folderId
      );
      if (!targetFolder) {
        return;
      }
      const currentWorkflowId = window.location.pathname.split("/").pop();
      const isWorkflowInFolder = targetFolder.workflows.some(
        (workflow) => workflow.id === currentWorkflowId
      );

      await deleteFolder(folderId, selectedFolderLabel);
      // 実行履歴キャッシュを無効化
      queryClient.invalidateQueries(["UploadSets"]);

      if (isWorkflowInFolder) {
        navigation("/views");
      }
      if (onClose) {
        onClose();
      }
    } catch (error) {
      // Error handling
    }
  }, [folderId, selectedFolderLabel, deleteFolder, onClose, navigation]);

  return (
    <CustomDialog
      open={true}
      onClose={onClose}
      title={`${selectedFolderLabel}を削除`}
      description={`このフォルダを削除すると、配下のすべてのルールも削除されます。 この操作は取り消せません。続行しますか？`}
      primaryButtonText="実行する"
      primaryButtonAction={handleDelete}
      secondaryButtonText="キャンセル"
      secondaryButtonAction={onClose}
    />
  );
};

const DeleteFolderPopup = forwardRef(DeleteFolderPopupComponent);
DeleteFolderPopup.displayName = "DeleteFolderPopup";

export default DeleteFolderPopup;
